export function createCheckeredBackground(
  size = "1.5em",
  color = "#000000",
  alpha = "11",
  bg = "transparent",
) {
  return {
    backgroundImage: `linear-gradient(to right, ${color}${alpha} 1px, ${bg} 1px), linear-gradient(to bottom, ${color}${alpha} 1px, ${bg} 1px);`,
    backgroundSize: `${size} ${size}`,
    backgroundRepeat: "repeat",
  };
}
